<template>
  <v-snackbar
    v-model="show"
    right
    top
    :color="userSettings.useDarkMode ? '' : 'grey black--text lighten-3'"
    :timeout="snackTimeout"
  >
    <v-progress-circular
      v-show="snackLoading"
      color="red"
      size="20"
      indeterminate
      class="mr-2"
    ></v-progress-circular>
    <v-icon class="pr-2" v-show="!snackLoading">info</v-icon>
    {{ message }}
    <v-btn flat color="primary" @click.native="show = false">Lukk</v-btn>
  </v-snackbar>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "TheSnackBar",
  data() {
    return {
      show: false,
      message: ""
    };
  },
  methods: {
    ...mapActions(["setSnack"])
  },
  computed: {
    ...mapState(["userSettings", "snackTimeout", "snackLoading"])
  },
  created: function() {
    this.$store.watch(
      state => state.snack,
      () => {
        const msg = this.$store.state.snack;
        if (msg !== "") {
          if (this.show) {
            this.show = false;
            setTimeout(() => {
              this.show = true;
            }, 1000);
          } else {
            this.show = true;
          }
          this.message = this.$store.state.snack;
        }
      }
    );
  }
};
</script>
